import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import { AlertContext, Box, Button, CheckmarkIcon, Snackbar, } from '../..';
import makeStyles from '@mui/styles/makeStyles';
import GlobalAlert from './GlobalAlert';
var useStyles = makeStyles(function (theme) { return ({
    container: {
        position: 'fixed',
        pointerEvents: 'none',
        width: '100%',
        zIndex: theme.zIndex.modal + 100,
        top: 24,
    },
    snackbar: {
        position: 'relative',
        top: 0,
    },
    dismissAllButton: {
        pointerEvents: 'initial',
        padding: theme.spacing(0.5),
    },
}); });
export var DismissAll = React.forwardRef(function (_a, ref) {
    var onClick = _a.onClick, rest = __rest(_a, ["onClick"]);
    return (React.createElement(Button, __assign({ ref: ref, variant: "text", startIcon: React.createElement(CheckmarkIcon, null), style: { pointerEvents: 'initial' }, onClick: onClick, "data-bw": "alertsDismissAll" }, rest), "Dismiss all"));
});
var GlobalAlerts = React.memo(function () {
    var classes = useStyles();
    var _a = useContext(AlertContext), alerts = _a.alerts, dismiss = _a.dismiss, dismissAll = _a.dismissAll, removeAlert = _a.removeAlert;
    return (React.createElement(Box, { display: "flex", flexDirection: "column", gap: "xs", className: classes.container },
        alerts.map(function (alert) { return (React.createElement(GlobalAlert, { key: alert.id, alert: alert, dismiss: dismiss, remove: removeAlert })); }),
        React.createElement(Snackbar, { className: classes.snackbar, open: alerts.filter(function (a) { return a.open; }).length > 1 },
            React.createElement(DismissAll, { onClick: dismissAll, className: classes.dismissAllButton }))));
});
export default GlobalAlerts;
//# sourceMappingURL=GlobalAlerts.js.map